import { useEffect } from 'react';

import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { showToast } from '@/components/@base/toast/show-toast';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import Auth from '@/components/app/auth/components';
import { useGetDownloadLink } from '@/components/app/product/services/hooks';
import { useGetProfile } from '@/components/layout/services/hooks';

import useCommonModalStore from '@/store/common-modal-store';

import imagesList from '@/constant/images-list';
import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;
const updaterId = process.env.NEXT_PUBLIC_UPDATER_ID!;

export const Updater = () => {
  const { profile } = useGetProfile();
  const { setShow } = useCommonModalStore();
  const { refetch, isLoading } = useGetDownloadLink(updaterId);
  const handleDownload = () => {
    if (profile) {
      refetch()
        .then((response) => {
          if (response.data) {
            const link = document.createElement('a');
            link.href = response.data;
            link.setAttribute('download', '');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            showToast({ message: 'Download link is not available', type: 'error' });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      localStorage.setItem('pendingDownload', 'true');
      handleAuthModal();
    }
  };
  const handleAuthModal = () => {
    setShow(true, {
      DialogPanelProps: {
        className: 'rounded-xl overflow-hidden shadow-none!  p-0! bg-transparent! ',
      },
      Body() {
        return <Auth />;
      },
    });
  };
  useEffect(() => {
    const shouldDownload = localStorage.getItem('pendingDownload');
    if (shouldDownload && profile) {
      localStorage.removeItem('pendingDownload');
      handleDownload();
    }
  }, [profile]);
  return (
    <Container className='mb-5 flex flex-col items-center justify-between rounded-md bg-[#88C8291A] pt-[19px] pr-[17px] pb-5 pb-[18px] pl-[21px] md:mb-[29px] md:h-[77px]! md:flex-row'>
      <Container className='flex items-start gap-3'>
        <XImage
          src={imagesList.icons.bulb}
          alt={productLocalization.getPluginFree}
          width={22}
          height={22}
        />
        <Text className='w-fit leading-[25px]! text-[#7BB81F] md:w-[475px] md:tracking-tighter'>
          {productLocalization.updaterDescription}
        </Text>
      </Container>
      <Container className='mt-2 mb-1 md:mt-0 md:mb-0'>
        <Button
          className='h-10 w-[190px] gap-1.5 rounded-md bg-[#81CF33] text-[15px] font-medium whitespace-nowrap text-white hover:bg-[#68aa27] md:w-[163px]'
          Icon={
            <XImage alt='download' src={imagesList.icons.download} width={16} height={16} />
          }
          isLoading={isLoading}
          onClick={handleDownload}
        >
          {productLocalization.getPluginFree}
        </Button>
      </Container>
    </Container>
  );
};
